export function DashboardPage() {
  return (
    <>
      <header className="admin-page-heading"><p className="admin-kicker">Overview</p><h1>Speaking dashboard</h1></header>
      <section className="admin-card-grid" aria-label="Admin sections">
        <a href="/admin/engagements"><strong>Engagements</strong><span>Update past and upcoming appearances</span></a>
        <a href="/admin/inquiries"><strong>Inquiries</strong><span>Review saved speaking requests</span></a>
        <a href="/admin/pages"><strong>Additional pages</strong><span>Create focused campaign pages</span></a>
        <a href="/admin/media"><strong>Media</strong><span>Manage approved imagery and files</span></a>
      </section>
    </>
  );
}
